import React from 'react'


export default function RMPLoader({}) {
    return <>Loading...</>
}